import React from 'react'
import marked from 'marked'
import { navigateTo } from 'gatsby-link'

import CustomHelmet from '../../../components/CustomHelmet'
import Hero from '../../../components/ProgramOverview/Hero'
import Row from '../../../components/Shared/Row'
import Column from '../../../components/Shared/Column'
import Signup from '../../../components/Shared/Signup'
import RFILightbox from '../../../components/Shared/RFILightbox'
import AdmissionsSignup from '../../../components/Shared/AdmissionsSignup'

import Button from '../../../components/Button'

class academyApplication extends React.Component {
    constructor()  {
        super()
        this.state = {
            urlParamsSet : false,
            urlParams: ''
        }
    }
    componentDidMount() {
        var iFrame = this.refs.application
        var my_awesome_script = document.createElement('script');

        my_awesome_script.setAttribute('src','https://tfaforms.com/js/iframe_resize_helper.js');

        this.refs.resizeHandler.appendChild(my_awesome_script);

        // document.body.classList.add('Academy-Application')
    }
    componentWillUnmount() {
        // document.body.classList.remove('Academy-Application')
    }

    render() {
        const { location } = this.props
        // const page = this.props.data.page.edges[0].node

        return (
            <div id="destinations-quiz">
                <div id="logo" style={{ position: 'absolute', top: '30px', left: '50px', zIndex: 900 }}>
                    <img src="/images/redesign/global-citizen-year-new-logo.svg" alt=""/>
                </div>
                <Hero
                    title={ 'Application' }
                />
                { /*<Row className="page-intro">
                    <Column width="8" offsetL="2" tablet="12">
                        <h2 className="h2">THANK YOU FOR YOUR INTEREST IN GLOBAL CITIZEN ACADEMY!</h2>
                        <p>The application period for Fall 2020 is now closed. To be notified when we launch the application for our next Academy session, please fill out the form below.</p>
                        <div>
                        </div>
                    </Column>
                </Row> */ }
                <Row className="page-intro">
                    <Column width="8" offsetL="2" tablet="12" className="text-center">
                    { /* <iframe src="https://www.tfaforms.com/4824719" frameBorder="0" height="1200" style={{ border: '0px', marginTop: '30px' }} ref="application"></iframe>  */ }
                    <h2 className="h2">The application period is currently closed.</h2>
                        <p>But you’ll soon be able to apply to the Fall 2022 semester of Global Citizen Year Academy. Sign up below to learn more and be notified when our next round of applications opens!</p>
                        <Button
                        text="Request Info"
                        href="/#signup"
                        style={{ marginTop: '30px' }} />
                        <div ref="resizeHandler"></div>
                    </Column>
                </Row>
            </div>
        )
    }
}

export default academyApplication



// WEBPACK FOOTER //
// ./src/pages/academy/apply/index.js